'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _player = require('player.js');

var PlayerJS = _interopRequireWildcard(_player);

var _createMarkup = require('../../../../utils/react/createMarkup');

var _createMarkup2 = _interopRequireDefault(_createMarkup);

require('./IFrameVideoPlayer.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib
// eslint-disable-line no-unused-vars

// Utils


// Styles


var getIFramePlayerPadding = function getIFramePlayerPadding(videoData) {
    var ratio = videoData.get('height') / videoData.get('width');
    return {
        paddingBottom: Math.floor(ratio * 100) + '%'
    };
};

var IFrameVideoPlayer = function (_React$Component) {
    _inherits(IFrameVideoPlayer, _React$Component);

    function IFrameVideoPlayer(props) {
        _classCallCheck(this, IFrameVideoPlayer);

        var _this = _possibleConstructorReturn(this, (IFrameVideoPlayer.__proto__ || Object.getPrototypeOf(IFrameVideoPlayer)).call(this, props));

        _this.cancelTimers = function () {
            _this.mountTimer && clearTimeout(_this.mountTimer);
            _this.readyTimer && clearTimeout(_this.readyTimer);
        };

        _this.dispatchPlayerReady = function () {
            if (_this.isReady) return;

            _this.isReady = true;
            _this.props.dispatchRichMediaReady();
        };

        _this.isReady = false;
        return _this;
    }

    _createClass(IFrameVideoPlayer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                dispatchRichMediaError = _props.dispatchRichMediaError,
                videoData = _props.videoData;


            if (!videoData) {
                dispatchRichMediaError();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (!this.container) return;

            var iFrame = this.container.querySelector('iframe.embedly-embed');
            var player = new playerjs.Player(iFrame); // eslint-disable-line no-undef

            // Wait a second before transitioning to the player in case the player does not
            // support the 'ready' event
            this.mountTimer = (0, _lodash.delay)(this.dispatchPlayerReady, 2000);

            player.on('ready', function () {
                _this2.cancelTimers();

                // Wait at most 1.5 seconds before transitioning to the player in case the player does not
                // support the 'play' event
                _this2.readyTimer = (0, _lodash.delay)(_this2.dispatchPlayerReady, 2000);

                player.on('play', _this2.dispatchPlayerReady);
                player.on('ended', _this2.props.dispatchRichMediaReturnToPreview);
                player.on('error', _this2.props.dispatchRichMediaError);
            });
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.cancelTimers();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var videoData = this.props.videoData;


            if (!videoData) return null;

            return _react2.default.createElement('div', { ref: function ref(c) {
                    _this3.container = c;
                },
                className: 'IFrameVideoPlayer',
                style: getIFramePlayerPadding(videoData),
                dangerouslySetInnerHTML: (0, _createMarkup2.default)(videoData.get('html')) });
        }
    }]);

    return IFrameVideoPlayer;
}(_react2.default.Component);

IFrameVideoPlayer.propTypes = {
    videoData: _propTypes2.default.object.isRequired,
    dispatchRichMediaReady: _propTypes2.default.func,
    dispatchRichMediaReturnToPreview: _propTypes2.default.func,
    dispatchRichMediaError: _propTypes2.default.func
};

exports.default = IFrameVideoPlayer;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/components/video/IFrameVideoPlayer.js
// module id = 2016
// module chunks = 0